import { BsChevronDown } from 'react-icons/bs'

export default {
  title: 'Scroll Indicator',
  icon: BsChevronDown,
  name: 'scrollIndicator',
  type: 'document',
  // __experimental_actions: ['update', 'publish'],
  fields: [
    {
      type: 'image',
      name: 'image',
      title: 'Image'
    }
  ]
}
